const getLoggingApiUrl = () => {
  const subdomain = window?.location?.host?.split('.')[0];
  switch (subdomain) {
    case 'orion-dev':
      return 'https://api-dev.crdigital.com';
    case 'orion-test':
      return 'https://api-test.crdigital.com';
    case 'orion':
      return 'https://api.crdigital.com';
    default:
      return 'http://localhost:3030';
  }
};

const config = {
  apiUrl: {
    orionAPI: process.env.REACT_APP_API_HOST || 'http://localhost:56607',
    orionApiV2: process.env.REACT_APP_API_HOST || 'http://localhost:56607/v2',
    alertAPI: process.env.REACT_APP_ALERT_API_HOST || 'http://localhost:58965',
    v1API: process.env.REACT_APP_V1_API_HOST || 'http://localhost:11688',
    reportingAPI: `${process.env.REACT_APP_REPORTING_API_HOST || 'http://localhost:50031'}/v1`,
    loggingAPI: getLoggingApiUrl()
  },
  // OIDC
  stsAuthority: process.env.REACT_APP_AUTH_URL || 'http://localhost:5000', // Security Token Service
  clientId: process.env.REACT_APP_IDENTITY_CLIENT_ID || 'js_oidc',
  clientRoot: window.location.origin,
  clientScope: 'openid profile email api1 api2.read_only roles V1EmailLogAPI ReportingAPI',
  //apiRoot: 'http://localhost:56607'
  buildVers: process.env.REACT_APP_BUILD_VERS || '1.0'
};
export default config;
